import {
	ADD_SONG_TO_FAVORITES_LIST,
	ADD_SONG_TO_FAVORITES_LIST_REQUEST,
	DELETE_SELECTED_SONG,
	DELETE_SELECTED_SONG_REQUEST,
	EDIT_SONG,
	EDIT_SONG_REQUEST,
	GET_ALL_SONGS_REQUEST,
	GET_COUNTRY_ARTISTS_REQUEST,
	GET_COUNTRY_SONGS_REQUEST,
	GET_COUNTRIES_WITH_SONGS_REQUEST,
	GET_GENRES_REQUEST,
	GET_PLAYLIST_SONGS_REQUEST,
	GET_RANDOM_SONGS_LIST_REQUEST,
	GET_SELECTED_COUNTRY_SONGS,	
	SET_SELECTED_COUNTRY,
	GET_USER_FAVORITE_SONGS_REQUEST,
	GET_USER_UPLOADED_SONGS_REQUEST,
	REMOVE_SONG_FROM_FAVORITES_LIST,
	REMOVE_SONG_FROM_FAVORITES_LIST_REQUEST,
	SELECT_SONG_TO_EDIT,
	SELECT_SONG_TO_VIEW_INFO,
	UPDATE_EDIT_SONG_VALUE	
} from '../constants/songs-action-types';

export function addSongToFavoritesList (payload){
	return {
		type:ADD_SONG_TO_FAVORITES_LIST,
		payload
	};
}

export function addSongToFavoritesListRequest (payload) {
	return {
		type: ADD_SONG_TO_FAVORITES_LIST_REQUEST,
		payload
	};
}

export function deleteSelectedSong (payload) {
	return {
		type: DELETE_SELECTED_SONG,
		payload
	};
}

export function deleteSelectedSongRequest (payload) {
	return {
		type: DELETE_SELECTED_SONG_REQUEST,
		payload
	};
}

export function editSong (payload) {
	return {
		type: EDIT_SONG,
		payload
	};
}

export function editSongRequest (payload) {
	return {
		type: EDIT_SONG_REQUEST,
		payload
	};
}

export const getAllSongsRequest = () => ({type: GET_ALL_SONGS_REQUEST});

export const getCountryArtistsRequest = (payload) => {
	console.log('pay', payload);
	return {
		type: GET_COUNTRY_ARTISTS_REQUEST,
		payload
	};
}

export const getCountrySongsRequest = (payload) => {
	return {
		type: GET_COUNTRY_SONGS_REQUEST,
		payload
	};
}

export const getCountriesWithSongsRequest = (payload) => {
	return {
		type: GET_COUNTRIES_WITH_SONGS_REQUEST,
		payload
	}
}

export const getGenresRequest = () => ({type: GET_GENRES_REQUEST});

export function getPlaylistSongsRequest (payload) {
	return {
		type: GET_PLAYLIST_SONGS_REQUEST,
		payload
	};
}

export function getSelectedCountrySongs (payload) {
	return {
		type: GET_SELECTED_COUNTRY_SONGS,
		payload
	};
}

export const getUserFavoriteSongsRequest = () => ({type: GET_USER_FAVORITE_SONGS_REQUEST});

export const getUserUploadedSongsRequest = () => ({type: GET_USER_UPLOADED_SONGS_REQUEST});

export function removeSongFromFavoritesList (payload){
	return {
		type:REMOVE_SONG_FROM_FAVORITES_LIST,
		payload
	};
}

export function removeSongFromFavoritesListRequest (payload){
	return {
		type:REMOVE_SONG_FROM_FAVORITES_LIST_REQUEST,
		payload
	};
}

export function setSelectedCountry (payload) {
	return {
		type: SET_SELECTED_COUNTRY,
		payload
	};
}

export function selectSongToEdit (payload) {
	return {
		type: SELECT_SONG_TO_EDIT,
		payload
	};
}

export function selectSongToViewInfo (payload) {
	return {
		type: SELECT_SONG_TO_VIEW_INFO,
		payload
	};
}

export function updateEditSongValue (payload) {
	return {
		type: UPDATE_EDIT_SONG_VALUE,
		payload
	};
}